module.exports = __webpack_public_path__ + "img/Momentum_Aria_Floodlight.f0157206.png";